const getRootDomain = (hostname) => {
    const parts = hostname.split('.').reverse();
    return parts.length >= 2 ? `${parts[1]}.${parts[0]}` : parts[0];
};

export default getRootDomain;
